import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ADMIN_CRM_CONTACTS_PATH,
    ADMIN_CRM_FEEDBACK_PATH,
    ADMIN_CRM_MAILING_LIST_PATH,
    ADMIN_CRM_REFERRAL_PATH,
    ADMIN_CRM_REVIEW_PATH,
} from "./crmRoutes";

const CRM_TAB_STORAGE_KEY = "admin.crm.tabIndex";

const CRM_TAB_PATHS = [
    ADMIN_CRM_MAILING_LIST_PATH,
    ADMIN_CRM_CONTACTS_PATH,
    ADMIN_CRM_REFERRAL_PATH,
    ADMIN_CRM_FEEDBACK_PATH,
    ADMIN_CRM_REVIEW_PATH,
];

function tabFromPath(pathname) {
    if (typeof pathname !== "string") return ADMIN_CRM_MAILING_LIST_PATH;
    if (pathname.includes("/contacts")) return ADMIN_CRM_CONTACTS_PATH;
    if (pathname.includes("/referral")) return ADMIN_CRM_REFERRAL_PATH;
    if (pathname.includes("/feedback")) return ADMIN_CRM_FEEDBACK_PATH;
    if (pathname.includes("/review")) return ADMIN_CRM_REVIEW_PATH;
    return ADMIN_CRM_MAILING_LIST_PATH;
}

function tabIndexFromPath(pathname) {
    const index = CRM_TAB_PATHS.indexOf(tabFromPath(pathname));
    return index >= 0 ? index : 0;
}

function saveCrmTabIndex(index) {
    try {
        localStorage.setItem(CRM_TAB_STORAGE_KEY, String(index));
    } catch {
        /* ignore quota / private mode */
    }
}

export function loadCrmTabPath() {
    try {
        const index = Number(localStorage.getItem(CRM_TAB_STORAGE_KEY));
        if (Number.isInteger(index) && CRM_TAB_PATHS[index]) {
            return CRM_TAB_PATHS[index];
        }
    } catch {
        /* ignore private mode */
    }
    return ADMIN_CRM_MAILING_LIST_PATH;
}

export default function CrmTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const value = tabFromPath(location.pathname);

    useEffect(() => {
        saveCrmTabIndex(tabIndexFromPath(location.pathname));
    }, [location.pathname]);

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
                value={value}
                onChange={(_, path) => {
                    saveCrmTabIndex(CRM_TAB_PATHS.indexOf(path));
                    navigate(path);
                }}
                variant="scrollable"
                allowScrollButtonsMobile
            >
                <Tab label="Mailing List" value={ADMIN_CRM_MAILING_LIST_PATH} />
                <Tab label="Contact" value={ADMIN_CRM_CONTACTS_PATH} />
                <Tab label="Referral" value={ADMIN_CRM_REFERRAL_PATH} />
                <Tab label="Feedback" value={ADMIN_CRM_FEEDBACK_PATH} />
                <Tab label="Review" value={ADMIN_CRM_REVIEW_PATH} />
            </Tabs>
        </Box>
    );
}
